<div class="mb-14">
  <p500-ui-select-field
    [label]="label"
    [formControl]="control"
    [data]="options"
    [clearable]="clearable"
    [disabled]="disabled"
  ></p500-ui-select-field>
</div>
